import {
  FilterType,
  buildTrainingRequestsDatatableFilter,
  useTrainingRequestsDatatable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export function statusFilter(source: ReturnType<typeof useTrainingRequestsDatatable>) {
  return buildTrainingRequestsDatatableFilter(source, {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: [
          {
            label: i18n.t('trainings.training_requests.requests.datatable.pending'),
            value: 'review',
          },
          {
            label: i18n.t('trainings.training_requests.requests.datatable.approved'),
            value: 'approved',
          },
          {
            label: i18n.t('trainings.training_requests.requests.datatable.rejected'),
            value: 'rejected',
          },
        ],
      },
    ],
    identifier: 'statusFilter',
    default: true,
    path: 'status',
    title: i18n.t('trainings.training_requests.requests.datatable.status'),
  })
}
